import axios from 'axios'

// There are some endpoints we never call, but we'll keep them just in case.
// https://github.com/zerapix/py-zkit/blob/main/zkit/conf.py#L36
const localPortsForPathPrefixes = {
  '/v1/': 8001, // pixyservice-api
  '/v2/pd/export/': 8002, // pixydocs-exporter
  '/v2/relay/': 8002, // pd-relay (previously pixydocs-exporter)
  '/v2/pd/': 8000, // pixydocs-api (docsapi app - Core API / Django)
  '/v2/pd-rules/': 8003, // pixydocs-rules
  '/v2/pd-tray/': 8004, // pd-tray
  '/v2/pd-ocr/': 8005, // pd-ocr
  '/v2/user/': 8006, // auth-manager
  '/v2/notify/': 8007, // ws-api-gw
  '/v2/pd-predict/': 8008, // pd-predict
  '/v2/dr-chrono/': 8009, // dr-chrono
  '/v2/logix/': 8000, // pixydocs-api (logix_api app)
  '/v2/pd-cloner/': 8010, // pd-cloner
  '/v2/pd-workflow/': 8011, // pd-workflow
  '/v2/run-py/': 8012, // run-py
  '/v2/relay-entrata/': 8013, // relay-entrata
  '/v2/pd-activity/': 8014, // pd-activity
  '/v2/template/': 8015, // pd-template
  '/v2/relay-qbo/': 8016, // relay-qbo
  '/v2/relay-ajera/': 8017, // relay-ajera
  '/v2/billing/': 8019, // pd-billing
  '/v2/relay-intacct/': 8020, // relay-intacct
}

function getCookie(name: string) {
  const cookies = document.cookie.split(';') // Split the string into individual cookies
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim() // Remove leading/trailing whitespace
    // Does this cookie string begin with the name we want?
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1) // Return the cookie value
    }
  }
  return '' // Return empty string if cookie not found
}

function getBaseUrl(url: string) {
  const base = 'http://localhost:'
  let baseUrl = ''
  for (const [path, portNumber] of Object.entries(localPortsForPathPrefixes)) {
    if (url.startsWith(path)) {
      baseUrl = `${base}${portNumber}`
      break
    }
  }
  if (baseUrl) return baseUrl

  return import.meta.env.VITE_PD_API_GATEWAY
}

const instance = axios.create({
  baseURL: import.meta.env.VITE_PD_API_GATEWAY,
})

// This sets up axios to always get the user's access token prior to a request and attach it to the request Authorization header
instance.interceptors.request.use(async function (config) {
  let authorization = ''
  const stytch_session_jwt = getCookie('stytch_session_jwt')
  authorization = `Bearer ${stytch_session_jwt}`
  if (config.headers) {
    config.headers.Authorization = authorization
  } else {
    config.headers = {
      Authorization: authorization,
    }
  }

  if (config.url && import.meta.env.VITE_ENVIRONMENT === 'local') {
    // Dynamically set baseURL based on the URL of the API call
    config.baseURL = getBaseUrl(config.url)
  }

  return config
})

// Add response interceptor for global error logging
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Import enrichScopeForHttpError dynamically to avoid circular dependency
    const { enrichScopeForHttpError } = await import('../sentry')
    enrichScopeForHttpError(error)
    return Promise.reject(error)
  },
)

export default instance
